import { forwardRef } from 'react'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'
import Modal, { ModalRef } from '@ui-components-3/ui/lib/components/Modal'
import { getLoggedInMemberId } from 'redux/selectors/members'
import { DASHBOARD, MEDICAL_OVERVIEW, createMedicalPath } from 'routes/paths'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const ModalContent = {
  account: {
    content: (t) => t('visitCreation.redirect.updateMedicalInfo'),
    getRoute: ({ memberId }) => createMedicalPath(MEDICAL_OVERVIEW, memberId),
    ctaLabel: (t) => t('visitCreation.redirect.updateInfo'),
  },
  dashboard: {
    content: (t) => t('visitCreation.redirect.activeVisit'),
    getRoute: () => DASHBOARD,
    ctaLabel: (t) => t('visitCreation.redirect.gotIt'),
  },
}

type AddPendingVisitRedirectModalProps = {
  queryValue: string
}

const AddPendingVisitRedirectModal = forwardRef<ModalRef, AddPendingVisitRedirectModalProps>(({ queryValue }, ref) => {
  const history = useHistory()
  const memberId = useSelector(getLoggedInMemberId)
  const redirectRoute = ModalContent[queryValue].getRoute({ memberId })
  const { t } = useTranslation()

  return (
    <Modal
      ref={ref}
      label={t('visitCreation.redirect.unavailable')}
      className="backdrop:backdrop-blur"
      onClose={() => history.push(redirectRoute)}
      footer={
        <Link to={redirectRoute} className="btn btn-neutral w-full">
          {ModalContent[queryValue].ctaLabel(t)}
        </Link>
      }
    >
      <p className="pb-s pt-xs text-neutral">{ModalContent[queryValue].content(t)}</p>
    </Modal>
  )
})

export default AddPendingVisitRedirectModal
